var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.BG=require("ttag");module.exports=$CLJS.BG;